$(document).ready(function() {
    $(".benefits-bar ul").slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            dots: false,
            arrows: false,
            autoplay:true,
            responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false,
                arrows: false,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: false,
                arrows: false,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
              }
            }
        ]
    });
    $(".shop-by-category-wrapper .slider-wrap-cat").slick({
              slidesToShow: 6,
              slidesToScroll: 6,
              infinite: true,
              dots: true,
              arrows: false,
              responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  infinite: true,
                  arrows: false,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  infinite: true,
                  arrows: false,
                }
              }              
          ]
      });
      $(".featured-collection-c .product-grid").slick({
              slidesToShow: 5,
              slidesToScroll: 5,
              infinite: false,
              dots: true,
              arrows: true,
              responsive: [
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  infinite: false,
                  dots: true,
                }
              },  
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: false,
                  dots: true,
                }
              },   
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  infinite: false,
                  dots: true,
                }
              }
          ]
      });
        $(".brands-wrapper .brand-slider").slick({
              slidesToShow: 6,
              slidesToScroll: 6,
              infinite: true,
              dots: true,
              arrows: false,
              responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  infinite: true,
                }
              },   
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll:3,
                  infinite: true,
                }
              }
          ]
      });
    //  setTimeout(function() {
    //   $(".related-products .product-grid").slick({
    //           slidesToShow: 5,
    //           slidesToScroll: 5,
    //           infinite: false,
    //           dots: true,
    //           arrows: false,
    //           responsive: [
    //           {
    //             breakpoint: 1200,
    //             settings: {
    //               slidesToShow: 4,
    //               slidesToScroll: 4,
    //               infinite: false,
    //               dots: true,
    //               arrows: false,
    //             }
    //           },  
    //           {
    //             breakpoint: 992,
    //             settings: {
    //               slidesToShow: 3,
    //               slidesToScroll: 3,
    //               infinite: false,
    //               dots: true,
    //               arrows: false,
    //             }
    //           },   
    //           {
    //             breakpoint: 768,
    //             settings: "unslick"
    //           }
    //       ]
    //   });
    // }, 1000);
   setTimeout(function() {
    
      }, 1000);
    $(".product .product__info-wrapper .product-form__input--dropdown .select select").focus(function(){
      $(this).parent().toggleClass("clicked");
    });
    const myInterval = setInterval(function() {
         if ( $('.tp-related-product.product-grid .grid__item').length){
           $(".related-products .product-grid").slick({
                slidesToShow: 5,
                slidesToScroll: 5,
                infinite: false,
                dots: true,
                arrows: false,
                responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: false,
                    dots: true,
                    arrows: false,
                  }
                },  
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: true,
                    arrows: false,
                  }
                },   
                {
                  breakpoint: 768,
                  settings: "unslick"
                }
            ]
        });

        
        // var related_size_li = $('.tp-related-product.product-grid .grid__item').length;
        // if(related_size_li >  4){
        //   $('#loadMoreRelated').show();
        // }
        // var y=4;
        // $('.tp-related-product.product-grid .grid__item').hide(); 
        // $('.tp-related-product.product-grid .grid__item:lt('+y+')').show();
          
        // $('#loadMoreRelated').click(function (e) {
        //     e.preventDefault();
        //     y= (y+4 <= related_size_li) ? y+4 : related_size_li;
        //     $('.tp-related-product li:lt('+y+')').show();
        //     console.log('y value',y);
        //     if(related_size_li == y){
        //       $('#loadMoreRelated').hide();
        //     }
        // });
        clearInterval(myInterval);
        }
    },1000);

  
     $('.mega-menu').on('mouseover', function() {
      $(this).attr('open','open');
     }).mouseleave(function() {
      $(this).removeAttr('open');
    });
    $(".footer .tabs_mb .footer-block__heading").click(function(){
      $(this).parent().toggleClass("active").siblings().removeClass("active");
    });  
  $(".localisation__wrapper .ui-dialog-titlebar-close").click(function(){
    $(".custom-dropdown .options-list").css("display","none");
  });  
    var btn = $('.backtotop');
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    }); 
    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '200');
    });


    // var size_li = $(".tp-product-shop-bundle li").length;
    // if(size_li >  4){
    //   $('#loadMore').show();
    // }
    // var x=4;
    // $('.tp-product-shop-bundle li:lt('+x+')').show();
    // $('#loadMore').click(function (e) {
    //     e.preventDefault();
    //     x= (x+4 <= size_li) ? x+4 : size_li;
    //     $('.tp-product-shop-bundle li:lt('+x+')').show();
    //     console.log('x value',x);
    //     if(size_li == x){
    //       $('#loadMore').hide();
    //     }
    // });
});

$(document).on('click', '.swatch .swatch-element input:checked:not(.notrigger)', function(e) { 

  $('.select__select').val($(this).val());
  console.log("this is testing");
  const event = new Event("change", {
    view: window,
    bubbles: true,
    cancelable: true
  });
  
  document.querySelector('[name="options[Shade]"]')[0].dispatchEvent(event);
  var selectedVariantTitle = $(this).val();
  var titleSplit = selectedVariantTitle.split("_");
  $('.shade-selected b').empty().append(titleSplit[0]+' :');
  $('.shade-selected span').empty().append(titleSplit[1]);
});


$(document).on('change', '.dropdown-Shade', function(e) { 
  
  var radioValue = $(this).val();
    $(".swatch-element.color input[name=option-0][value='" + radioValue + "']").addClass("notrigger");
    $(".swatch-element.color input[name=option-0][value='" + radioValue + "']").trigger("click");
    setTimeout(function(){
      $(".swatch-element.color input[name=option-0][value='" + radioValue + "']").removeClass("notrigger");
    },2000);
    var selectedVariantTitle = radioValue;
    var titleSplit = selectedVariantTitle.split("_");
    $('.shade-selected b').empty().append(titleSplit[0]+' :');
    $('.shade-selected span').empty().append(titleSplit[1]);
 
});

$(".cart-page .cart__content  .accordian__title").click(function(){
  $(this).parent().toggleClass("active");
}); 

document.addEventListener('DOMContentLoaded', function() {
  const isMobile = window.innerWidth <= 768;
  const isDesktop = window.innerWidth >= 1024;

  const observer = new MutationObserver(() => {
    const mobileDescription = document.querySelector('.product__media-wrapper .product__description');
    const desktopAccordion = document.querySelector('.product__info-wrapper .product__accordion');
    const desktopDescription = document.querySelector('.product__info-wrapper .product__description');

    if (isMobile && mobileDescription) {
      mobileDescription.remove();
    }

    if (isDesktop) {
      if (desktopAccordion) desktopAccordion.remove();
      if (desktopDescription) desktopDescription.remove();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => {
    const mobileDescription = document.querySelector('.product__media-wrapper .product__description');
    const desktopAccordion = document.querySelector('.product__info-wrapper .product__accordion');
    const desktopDescription = document.querySelector('.product__info-wrapper .product__description');

    if (isMobile && mobileDescription) {
      mobileDescription.remove();
    }

    if (isDesktop) {
      if (desktopAccordion) desktopAccordion.remove();
      if (desktopDescription) desktopDescription.remove();
    }
  }, 1500);
});

  const allowedIPs = ['157.49.139.59', '98.76.54.32'];
  function isAdminMode() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('adminmode') === 'true') {
      document.cookie = "adminmode=true; path=/";
      return true;
    }
    return document.cookie.includes("adminmode=true");
  }

  function protectPage() {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });
    document.addEventListener('keydown', function (e) {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key.toUpperCase())) ||
        (e.ctrlKey && e.key.toUpperCase() === 'U')
      ) {
        e.preventDefault();
      }
    });
  }

  if (!isAdminMode()) {
    fetch('https://api.ipify.org?format=json')
      .then(res => res.json())
      .then(data => {
        const ip = data.ip;
        if (!allowedIPs.includes(ip)) {
          protectPage();
        }
      })
      .catch(() => {
        protectPage();
      });
  }

document.querySelectorAll("button[data-address-id]").forEach(button => {
  button.addEventListener("click", function() {
    const addressId = this.getAttribute("data-address-id");
    const editAddressDiv = document.getElementById(`EditAddress_${addressId}`);
    if (editAddressDiv) {
      editAddressDiv.style.display = (editAddressDiv.style.display === "none" || !editAddressDiv.style.display) ? "block" : "none";
    }
  });
});